import React, { useState, useRef, useLayoutEffect } from 'react'

// Ajusta dinámicamente el tamaño de fuente para que el valor SIEMPRE quepa en
// su contenedor, sin recortes ni puntos suspensivos. Mide el ancho real de la
// caja (no del viewport) y baja el font-size desde `max` hasta `min` px hasta
// que el texto no se desborde. Se recalcula al cambiar el tamaño (ResizeObserver).
export default function AutoFitValue({ children, color, max = 21, min = 11 }) {
  const boxRef = useRef(null)
  const textRef = useRef(null)
  const [size, setSize] = useState(max)

  useLayoutEffect(() => {
    const fit = () => {
      const box = boxRef.current
      const text = textRef.current
      if (!box || !text) return
      let lo = min, hi = max, best = min
      // Búsqueda: probamos tamaños y nos quedamos con el mayor que quepa.
      for (let i = 0; i < 12; i++) {
        const mid = (lo + hi) / 2
        text.style.fontSize = mid + "px"
        if (text.scrollWidth <= box.clientWidth) { best = mid; lo = mid } else { hi = mid }
      }
      text.style.fontSize = best + "px"
      setSize(best)
    }
    fit()
    const ro = new ResizeObserver(fit)
    if (boxRef.current) ro.observe(boxRef.current)
    return () => ro.disconnect()
  }, [children, max, min])

  return (
    <div ref={boxRef} style={{ width: "100%", overflow: "hidden" }}>
      <span
        ref={textRef}
        style={{
          display: "inline-block", whiteSpace: "nowrap", fontWeight: 700,
          lineHeight: 1.15, color: color || "inherit", fontSize: size + "px",
        }}
      >
        {children}
      </span>
    </div>
  )
}
